<template>
  <emd-tabs
    :tabs="tabs"
    @changed="changed"
  >
    <template #infos>
      <section
        v-if="showLoading"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader type="_invert" />
      </section>
      <payment-links-info v-else />
    </template>

    <template #orders>
      <orders-table />
    </template>

    <template #subscriptions>
      <subscriptions-table />
    </template>
  </emd-tabs>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { EmdLoader, EmdTabs } from 'emerald-vue/src/components'

import { TABS, ORDERS_TAB } from '../enums/payment-links-tabs.enum'

import PaymentLinksInfo from './Infos/index.vue'

export default {
  name: 'PaymentLinksDetail',

  components: {
    EmdTabs,
    EmdLoader,
    PaymentLinksInfo,
    SubscriptionsTable: () =>
      import('../../Recurrences/Subscriptions/SubscriptionsTable.vue'),
    OrdersTable: () => import('../../Payments/Orders/OrdersTable.vue')
  },

  data () {
    return {
      queryString: {
        size: 30
      }
    }
  },

  computed: {
    ...mapGetters([
      'merchantId',
      'accountId',
      'userRole',
      'PAYMENTS_LINKS_DETAIL'
    ]),
    ...mapGetters({
      showLoading: 'PAYMENTS_LINKS_DETAIL_IS_LOADING'
    }),

    tabs () {
      const paymentsLinksType =
        this.PAYMENTS_LINKS_DETAIL?.payment_link_type ?? ORDERS_TAB.slotName

      return TABS.map(item => {
        if (item.shouldIsVisibled) {
          item.enabled = item.shouldIsVisibled(
            paymentsLinksType,
            this.userRole.key
          )
        }
        return { ...item, label: this.$t(item.slotName) }
      })
    },
    startDate () {
      return this.$route.query.created_at
    },
    endDate () {
      return new Date().toISOString()
    }
  },

  methods: {
    ...mapActions(['GET_ORDERS', 'GET_SUBSCRIPTIONS']),

    getOrders () {
      return this.GET_ORDERS({
        merchantId: this.merchantId,
        accountId: this.accountId,
        query: {
          ...this.queryString,
          start_date: this.startDate,
          end_date: this.endDate,
          any_ids: [this.PAYMENTS_LINKS_DETAIL.id]
        }
      })
    },

    getSubscriptions () {
      return this.GET_SUBSCRIPTIONS({
        merchantId: this.merchantId,
        accountId: this.accountId,
        query: {
          ...this.queryString,
          period_type: 'interval',
          created_since: this.startDate,
          created_until: this.endDate,
          any_ids: [this.PAYMENTS_LINKS_DETAIL.id]
        }
      })
    },

    changed ({ slotName }) {
      const getters = {
        orders: () => {
          this.getOrders()
        },
        subscriptions: () => {
          this.getSubscriptions()
        }
      }

      // eslint-disable-next-line no-unused-expressions
      getters[slotName]?.()
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "infos": "Informações",
      "orders": "Pedidos",
      "subscriptions": "Assinaturas"
    },
    "en-US": {
      "infos": "Informations",
      "orders": "Orders",
      "subscriptions": "Subscriptions"
    }
  }
</i18n>
